import React from 'react';

var BtnDelete = function BtnDelete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.485.707L7.778 0 4.243 3.536.707 0 0 .707l3.536 3.536L0 7.778l.707.707L4.243 4.95l3.535 3.535.707-.707L4.95 4.243z"
  }));
};

BtnDelete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.4854 8.4854"
};
import IconButton from "../IconButton";
import Fade from "../Fade";
import createStyles from "../createStyles";
var useStyles = createStyles(function (theme) {
  return {
    root: {
      color: theme.palette.secondary["default"],
      '&:hover': {
        color: theme.palette.primary["default"]
      }
    }
  };
});

var PickerClearButton = function PickerClearButton(_ref) {
  var show = _ref.show,
      onClick = _ref.onClick,
      asSuffix = _ref.asSuffix;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Fade, {
    show: show,
    mountOnEnter: true,
    "data-qa": "picker-clear-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.root,
    component: "span",
    size: "xs",
    position: asSuffix ? 'suffix' : undefined,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(BtnDelete, {
    width: 12,
    height: 12
  })));
};

export default PickerClearButton;